import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cefc17d6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cefc17d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefc17d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cefc17d6')) {
      api.createRecord('cefc17d6', component.options)
    } else {
      api.reload('cefc17d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cefc17d6&scoped=true&", function () {
      api.rerender('cefc17d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/settings/develop/index.vue"
export default component.exports